import React from 'react'
import { Linking, Text } from 'react-native'

const URL_RE = /((?:https?:\/\/|www\.)[^\s]+)/gi

/** Split text into ordered segments; url is non-null for link segments. Pure. */
export const splitLinks = (text) => {
  const out = []
  let last = 0
  const s = String(text ?? '')
  s.replace(URL_RE, (match, _g, offset) => {
    if (offset > last) out.push({ text: s.slice(last, offset), url: null })
    out.push({ text: match, url: match })
    last = offset + match.length
    return match
  })
  if (last < s.length) out.push({ text: s.slice(last), url: null })
  return out.length ? out : [{ text: s, url: null }]
}

/** Add https:// when the URL has no scheme. */
export const toHref = (url) => (/^https?:\/\//i.test(url) ? url : `https://${url}`)

export default function LinkifiedText({ children, style, linkColor }) {
  const segments = splitLinks(children)
  return (
    <Text style={style}>
      {segments.map((seg, i) =>
        seg.url ? (
          <Text
            key={i}
            // eslint-disable-next-line react-native/no-inline-styles
            style={{ color: linkColor, textDecorationLine: 'underline' }}
            onPress={() => Linking.openURL(toHref(seg.url)).catch(() => {})}
          >
            {seg.text}
          </Text>
        ) : (
          seg.text
        ),
      )}
    </Text>
  )
}
